import { GrantType, ResourcePermission } from "./orgSettings";

export enum WorkspaceSortByType {
    WORKSPACE = "workspaceName",
    ROLE = "permissions",
}

export enum WorkspaceRole {
    EDIT = "edit",
    VIEW = "view"
}

export interface Workspace {
    name: string,
    guid: string,
    url: string,
    icon: string,
    groupCount: number,
    userCount: number
}

export interface IUserWorkspaceData {
    appId: number,
	icon: string,
	name: string,
    permission: ResourcePermission,
    grantType: GrantType
}